export type OpDataField =
  | "NUMBER_OF_KMS"
  | "NUMBER_OF_TRAINSETS"
  | "NUMBER_OF_COACHES_PER_TRAIN"
  | "NUMBER_OF_TRIPS"
  | "NUMBER_OF_WCS_PER_COACH";

export type CoachTypeAggregate = "ERS" | "P2" | "TOTAL";

export const opDataFieldBaseLabel: Record<OpDataField, string> = {
  NUMBER_OF_KMS: "Number of kms",
  NUMBER_OF_TRAINSETS: "Number of trainsets",
  NUMBER_OF_COACHES_PER_TRAIN: "Coaches per train",
  NUMBER_OF_TRIPS: "Number of trips",
  NUMBER_OF_WCS_PER_COACH: "WCs per coach",
};

export const coachTypeAggregateSuffix: Record<CoachTypeAggregate, string> = {
  ERS: "ERS",
  P2: "P2",
  TOTAL: "total",
};

export const opDataVariableLabel = (
  opDataField: OpDataField,
  coachTypeAggregate: CoachTypeAggregate,
): string =>
  `${opDataFieldBaseLabel[opDataField]} (${coachTypeAggregateSuffix[coachTypeAggregate]})`;
